<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >
                    
                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        

                    <!-- Row -->
                    <div class="row">
                       
                        <div class="col-lg-12 col-xs-12 col-xl-6">
                            <p class="page-text margin-bottom-20 margin-top-0">
                                Visualize abaixo os seus documentos.
                            </p>                           
                            <h5 class="block-title">
                                <i class="las la-list"></i>
                                Lista de documentos
                            </h5>
                        </div>          

                        <div class="col-xs-12 col-xl-12">

                            <form method="get" style="width: 100%;" novalidate="" class="margin-bottom-0" v-on:submit.prevent="get">
                                <div class="row">
                                    <div class="col-lg-3 col-xs-6 col-xl-2 col-md-5">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>De:</h5>
                                            <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-lg-3 col-xs-6 col-xl-2 col-md-5">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Até:</h5>
                                            <input type="date" data-placeholder="___ /____ /_____" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                        </div>
                                    </div>    
                                    <div class="col-lg-2 col-xs-6 col-xl-2 col-md-2" style="padding-right: 0px;">
                                        <div class="submit-field" v-if="data">
                                            <h5>Área:</h5>
                                            <select class="with-border" v-model="form.area">
                                                <option value="">Todas</option>
                                                <option v-for="(item, index) in data.areas" v-if="data" :key="item.id" :value="item.id">{{item.nome}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-md-2 col-xs-4 hidden-xs hidden-md" style="">
                                        <div class="submit-field">
                                            <div class="clearfix" style="margin-top: 21px;"></div>
                                            <button type="submit" class="button green small" style="height: 40px">
                                                <i class="las la-search"></i>
                                                Filtrar
                                            </button>                                          
                                        </div>
                                    </div>                                    

                                    <div class="col-lg-3 col-md-4 col-xs-5 hidden-lg hidden-xl" style="text-align: right;">
                                        <div class="submit-field">
                                            <div class="hidden-xl hidden-lg hidden-sm hidden-md" style="margin-top: 22px;"></div>
                                            <div class="hidden-xs clearfix hidden-xl hidden-md" style="margin-top: 32px;"></div>
                                            <button type="submit" class="button green small block-mobile" style="height: 40px">
                                                <i class="las la-search"></i>
                                                Filtrar
                                            </button>                                          
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 
                            <div  class="">
                                <div class="row margin-bottom-25" v-if="data.itens.length > 0">
                                    <div class="col-xs-12">
                                        <button type="button" v-on:click="selecionarTodosDocumentos()" class="button gray small" style="font-size: 12px">
                                            <i v-if="!selecionarTodosDocumentosAtivo" class="las la-check-square"></i>
                                            <i v-if="selecionarTodosDocumentosAtivo" class="las la-minus-square"></i>
                                            Selecionar todos
                                        </button>
                                        <button type="button" v-on:click="exportarDocumentos()" class="button gray small" style="font-size: 12px">
                                            <i class="las la-download"></i>
                                            Salvar selecionados
                                        </button>                                            
                                    </div>
                                </div>                                    
                            </div>                                   
                        </div> 

                        <div class="col-xl-12">
                            <h5 v-if="data.itens.length == 0 && data.loaded" class="empty">
                                <i class="las la-times"></i>
                                Nenhum resultado encontrado.
                            </h5>
                        </div>      

                        <div class="col-lg-12" v-if="data">
                            <div class="attachments-container">
                                <div class="attachment-box"  v-for="(item, index) in data.itens">
                                    <span>
                                        <div class="checkbox">
                                            <input type="checkbox" :id="'item-documento-' + item.id" true-value="true" false-value="false" v-model="item.selecionado" >
                                            <label :for="'item-documento-' + item.id" style="padding-left: 26px"><span class="checkbox-icon"></span> {{item.endereco}}</label>
                                        </div>                                             
                                        <a style="cursor: pointer;" v-on:click="openPDF($root.config.url + '/viewer/web/viewer.php?_cod=' + $root.user.cod + '&_token=' + $root.user.token + '&idDocumento=' + item.id, item)">
                                            <!-- {{item.endereco}} -->
                                            <br>
                                            <div class="dashboard-status-button color-secondary" style="font-size: 12px !important">
                                                {{item.listaIndice[4].valor}}
                                            </div>
                                        </a>
                                    </span>                                               
                                    <i style="width: 100%;">
                                        {{item.listaIndice[9].valor}}
                                        <button type="button" class="button color-green small float-right exportar-pdf" v-on:click.stop.prevent="exportarPDF($root.config.url + '/viewer/web/viewer.php?_cod=' + $root.user.cod + '&_token=' + $root.user.token + '&idDocumento=' + item.id + '&download=1', item)" style="font-size: 14px; font-weight: bold;">
                                            <span class="las la-download" style="position: relative; top: 0px; margin-bottom: 0px !important; line-height: 12px !important;"></span>
                                            Salvar
                                        </button>                                             
                                    </i>

                                </div>

                            </div>
                            <br><br><br>                                                                
                        </div>


                    </div>

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Ged',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];
            return date;

        },
        formatDateTime: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        }, 
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "selecionarTodosDocumentosAtivo": false,
            "loaded":               false,
            "data":                 {
                "areas":            [],
                "itens":            []
            },
            "loading": {
                "submit":           false
            },           
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                // "CD_PESSOA_FISICA": 32957,
                // "CD_PESSOA_FISICA": 466913,
                "tipo":             "documentos",                
                "area":             "",
                "dataInicio":       "",
                "dataFinal":        ""
            },
        }
    },
    watch: {
                  
    },
    methods: {     
        exportarDocumentos: function() {
            var self        = this;
            console.log("exportarDocumentos()");

            return new Promise(function(resolve, reject) {

                var itens           = [];
                var count           = 0;
                var limite          = 100;
                self.data.itens.forEach(function(item) {
                    if (count < limite) {
                        if (item.selecionado) {
                            count++;
                            itens.push(item.id);

                            self.$root.addLog({
                                "acao":             "EXPORTAR_GED_PACIENTE", 
                                "pessoaFisicaNome": self.$root.user.nome,
                                "pessoaFisicaCod":  self.$root.user.codigoIntegracao,
                                "descricao":        item.listaIndice[4].valor + " - " + item.endereco,
                                "referenciaCod":    item.id
                            });                            
                        }
                    }
                });

                if (count == limite) {
                    alert("Atenção, o limite para exportação é de " + limite + " documentos.");
                }

                if (itens.length == 0) {
                    reject("Nenhum documento selecionado");
                    return false;
                }

                if (itens.length >= 10) {
                    alert("Por favor, aguarde enquanto os documentos estão sendo processados, pode demorar alguns segundos.")
                }

                console.log("Itens selecionados:", itens);

                // self.data.itens.forEach(function(item) {
                //     if (item.selecionado) {
                //         self.$root.addLog({
                //             "acao":             "EXPORTAR_GED_PACIENTE", 
                //             "pessoaFisicaNome": self.$root.user.nome,
                //             "pessoaFisicaCod":  self.$root.user.codigoIntegracao,
                //             "descricao":        item.listaIndice[4].valor + " - " + item.endereco,
                //             "referenciaCod":    item.id
                //         });
                //     }
                // });

                loading.show();

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "acao":         "exportar-multiplos",
                    "id":           itens,
                };
                    
                axios.put("api/ged.php", form, {"timeout": 300000})
                .then(response => {

                    console.log("exportarDocumentos()", "success", response.data)
                    loading.hide();
                    if (response.data.link) {
                        window.open(response.data.link, "_system");
                    }
                    resolve(response);
                    // alert(response.data.message);

                })
                .catch(error => {

                    reject(error);
                    console.log("exportarDocumentos()", "error", error.data)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                });
               
               
            });   
        },       
        selecionarTodosDocumentos: function() {
            var self    = this;
            
            self.selecionarTodosDocumentosAtivo = (self.selecionarTodosDocumentosAtivo ? false : true);
            console.log("selecionarTodosDocumentos()");
            self.data.itens.forEach(function(item) {
                console.log(">", item);
                item.selecionado = self.selecionarTodosDocumentosAtivo;
            });
            self.$forceUpdate();
        },     
        openPDF: function(url, item) {
            console.log("openPDF", url, item.endereco, item.listaIndice[4].valor)
            var self = this;
            // return false;
            window.open(url, "_blank", "location=yes,hideurlbar=yes,hidenavigationbuttons=yes");

            self.$root.addLog({
                "acao":             "VISUALIZAR_GED_PACIENTE", 
                "pessoaFisicaNome": self.$root.user.nome,
                "pessoaFisicaCod":  self.$root.user.codigoIntegracao,
                "descricao":        item.listaIndice[4].valor + " - " + item.endereco,
                "referenciaCod":    item.id
            });

        },
        exportarPDF: function(url, item) {
            console.log("exportarPDF", url, item);
            var self = this;
            // return false;            
            window.open(url, "_system");

            self.$root.addLog({
                "acao":             "EXPORTAR_GED_PACIENTE", 
                "pessoaFisicaNome": self.$root.user.nome,
                "pessoaFisicaCod":  self.$root.user.codigoIntegracao,
                "descricao":        item.listaIndice[4].valor + " - " + item.endereco,
                "referenciaCod":    item.id
            });           
        },  
        // openPDF: function(url) {
        //     console.log("openPDF", url)
        //     window.open(url, "_blank", "location=yes,hideurlbar=yes,hidenavigationbuttons=yes");
        // },
        // exportarPDF: function(url) {
        //     console.log("exportarPDF", url)
        //     window.open(url, "_system");
        // },             
        get: function() {
            var self        = this;
            console.log("get()");
            self.data.loaded    = false;
            loading.show();
            return new Promise(function(resolve, reject) {
                axios.get("api/ged.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = JSON.parse(JSON.stringify(response.data.result));
                    self.data.loaded    = true;
                    self.$forceUpdate();
                    loading.hide();
                    console.log(">", self.data)
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }        
    },
    created: function() {
        var self = this;

        loading.show();

        self.$root.addLog({
            "acao":             "VISUALIZAR_GED", 
            "pessoaFisicaNome": self.$root.user.nome,
            "pessoaFisicaCod":  self.$root.user.codigoIntegracao,            
            "referenciaCod":    ""
        });


        Promise.all([
            self.get()
        ]).then(function() {
        
            setTimeout(function() {
                loading.hide();
            }, 500);
            
        }).catch(function(error) {
            loading.hide();
        });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .submit-field h5 {
        font-weight: 400 !important;
    }

    .table td button i {
        font-size: 20px !important;
        color: #fff;
    }
    .table td button {
        margin-top: 0px !important;
    }
    .table td {
        /*border-right: none;*/
        /*border-left: none;*/
    }
    .table td input, .table td select {
        margin-top: 0px;
        margin-bottom: 0px;
        text-align: left
    }
    .read-only {
        pointer-events: none !important;
        -webkit-touch-callout: none;                /* prevent callout to copy image, etc when tap to hold */
        -webkit-text-size-adjust: none;             /* prevent webkit from resizing text to fit */
        -webkit-user-select: none;             
    }
    .attachment-box {
        border: none !important;
    }
    div.float-right {
        float: right;
        display: inline-block;
    }
    .buttons {
        position: absolute;
        bottom: 10px;
        right: 10px;        
    }
    .attachment-box small div {
        font-size: 12px;
    }
    .attachment-box small {
        color: #888;
        display: block;
    }
    .attachment-box span {
        font-size: 16px !important;
        margin-bottom: 5px;
    }
    .td-50 {
        width: 50%;
        display: inline-block;
    }
    .td-50-l {
        border-right: 0px !important;
    }
    small.dark {
        color: #555;
    }
    small.dark i {
        color: var(--theme-color-primary);
    }
    .dashboard-status-button.color-secondary {
        top: 8px;
    }
    .menu-dropdown {
        margin-top: 0px;
        right: 3px;
        position: absolute !important;
    }
    .menu-dropdown .button {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }
    .menu-dropdown ul li a:after {
        display: none !important;
    }

    .menu-dropdown ul li ul {
        right: 0px;
        left: auto !important;
        top: 85px;
    }
    .menu-dropdown ul ul:after {
        left: auto !important;
        right: 25px;
        border-bottom: 5px solid var(--theme-color-primary) !important;
    }
    .menu-dropdown .dropdown-nav {
        background: var(--theme-color-primary) !important;
    }
    .menu-dropdown .dropdown-nav li a{
        color: #fff !important;
    }

    .exportar-pdf {
        padding-top: 0px;
        padding-bottom: 0px !important;
        line-height: 12px;
        position: relative;
        left: -32px;
        font-size: 12px;
        height: 20px;
    }        
</style>



// WEBPACK FOOTER //
// src/components/Ged.vue